import { addDisplayName, addHandlers, flowMax } from 'ad-hok'
import { FC } from 'react'
import { addLocation, addNavigate } from 'shared/src/utils/addNavigate'
import { addAuthContext } from 'shared/src/utils/auth'

import roundupIcon from 'assets/menu-roundup-icon.svg'
import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { makeRoundupUrl } from 'utils/routes'
import { Button } from '../Button'

interface Props {
  className?: string
}

export const RoundupButton: FC<Props> = flowMax(
  addDisplayName('RoundupButton'),
  addNavigate,
  addAuthContext,
  addLocation,
  addHandlers({
    onClick:
      ({ navigate, isAuthenticated, navigateToLogin }) =>
      () => {
        if (isAuthenticated) {
          navigate(makeRoundupUrl(), { state: { showBackButton: true } })
        } else {
          navigateToLogin({
            loginTrigger: 'roundup',
            returnTo: makeRoundupUrl(),
            showBackButton: true,
          })
        }
      },
  }),
  addTranslationHelpers,
  ({ onClick, t, className }) => (
    <Button onClick={onClick} className={className}>
      <img src={roundupIcon} alt={t('roundup.alt')} />
    </Button>
  )
)
